<template>
  <div>
    <section class="container-fluid my-4 col-md-10 offset-md-2">
      <h4 class="my-4">Tipos de <strong>Tarefas</strong></h4>

      <div class="mb-3">
        <router-link :to="{ name: 'task-type-register' }" class="btn btn-primary btn-sm">
          + Novo Tipo de Tarefa
        </router-link>
      </div>

      <div class="well mb-4">
        <input
          type="text"
          class="form-control"
          placeholder="Filtrar a lista abaixo"
          v-model="search"
        />
      </div>

      <table class="table table-bordered table-striped table-hover">
        <thead>
          <tr>
            <th class="text-center">#</th>
            <th>Nome</th>
            <th width="98px"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" :key="item.id">
            <td class="text-center">{{ item.id }}</td>
            <td>{{ item.name }}</td>
            <td>
              <ButtonEdit :to="{ name: 'task-type-edit', params: { id: item.id } }" />
              <ButtonDelete @delete="handlerDelete(item.id, 'task-types')" />
            </td>
          </tr>
        </tbody>
      </table>

      <Pagination :source="pagination" @navigate="navigate" />
    </section>
  </div>
</template>

<script>
import api from "@/services";
import Pagination from "@/components/Pagination.vue";
import ButtonEdit from "@/components/ButtonEdit.vue";
import ButtonDelete from "@/components/ButtonDelete.vue";
import { serialize, handlerDelete } from "@/helpers";

export default {
  name: "TaskTypeList",
  components: { Pagination, ButtonEdit, ButtonDelete },
  data() {
    return {
      search: "",
      pagination: {},
      items: [],
    };
  },
  methods: {
    handlerDelete,
    navigate(page) {
      this.getItens(page);
    },
    async getItens(page = 1) {
      const query = serialize({ search: this.search });
      const { data } = await api.get(`/task-types?page=${page}${query}`);
      this.items = data.data;
      this.pagination = data;
    },
  },
  async mounted() {
    this.getItens();
  },
  watch: {
    search() {
      this.getItens();
    },
  },
};
</script>
